/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useContext } from "react";
import { DebounceInput } from "react-debounce-input";

import { LayoutContext } from "../../components/layout";

const AllReportsFilter = ({ onFilterChange, filter, defaultValue }) => {
  const { user } = useContext(LayoutContext);
  // const [filter, setFilter] = useState(null);

  // useEffect(() => {
  //   if (onFilterChange) onFilterChange(filter);
  // }, [filter]);

  const onChange = (e) => {
    const elem = e.target;
    const dataSet = elem.dataset;
    const tfilter = { ...filter };
    if (elem.value) tfilter[dataSet.key] = { ...dataSet, value: elem.value };
    else if (tfilter[dataSet.key]) delete tfilter[dataSet.key];
    onFilterChange({ ...tfilter });
  };
  return (
    <form className="search toggleSearch" id="searchContent">
      {/* <small>
    <pre>{JSON.stringify(filter, null, 2)}</pre>
   </small> */}
      <div className="advOpt">
        <div className="row rowStretch">
          <div className="col col-m-50 col25">
            <label className="inCal">
              <span>Last Name</span>
              <DebounceInput
                debounceTimeout={800}
                type="text"
                placeholder="Search by Last Name..."
                value={(filter && filter["family"]?.value) || ""}
                onChange={onChange}
                data-key="family"
                data-com="$lk"
              />
            </label>
          </div>
          <div className="col col-m-50 col25">
            <label className="inCal">
              <span>First Name</span>
              <DebounceInput
                debounceTimeout={800}
                type="text"
                placeholder="Search by First Name..."
                value={(filter && filter["name"]?.value) || ""}
                onChange={onChange}
                data-key="name"
                data-com="$lk"
              />
            </label>
          </div>
          <div className="col col-m-50 col25">
            <label className="inCal">
              <span>Email</span>
              <input
                type="text"
                placeholder="Search by Email..."
                value={(filter && filter["email"]?.value) || ""}
                onChange={onChange}
                data-key="email"
                data-com="$lk"
              />
              <i className="ti ti-calendar"></i>
            </label>
          </div>
          <div className="col col-m-50 col25">
            <label className="inCal">
              <span>Location</span>
              <select onChange={onChange} data-key="locations.name" data-com="$lk">
                <option value="">Search by Location...</option>
                {user?.locations?.map((location) => (
                  <option key={location.id} value={location.name}>
                    {location.name}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>
      </div>
    </form>
  );
};

export default AllReportsFilter;
